import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import Highcharts from 'highcharts';
import moment, { Moment } from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-employee-dashboard-v1',
  templateUrl: './employee-dashboard-v1.component.html',
  styleUrls: ['./employee-dashboard-v1.component.scss']
})

export class EmployeeDashboardV1Component implements OnInit {

  /*  Year and Month Datepicker */
  @Input() max: any;
  tomorrow = new Date();
  date = new FormControl(moment());
  selectedDate: any;
  profileId: any;

  chosenYearHandler(normalizedYear: any) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.getFullYear());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: any, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.getMonth());
    this.date.setValue(ctrlValue);
    const m: Moment = ctrlValue;
    if (m) {
      this.selectedDate = m.format('YYYY-MM-DD HH:mm:ss');
      this.getUserTimeSheetInfo(new Date(this.selectedDate));
      this.getDaysInYear(m.format('YYYY'));
    }
    datepicker.close();
  }

  /* Employee Metrics chart info  */
  highcharts = Highcharts;
  chartOptions: any;

  month: Array<number> = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  todayDate = new Date();
  dynamicDate: any = [];
  tenantId: string = '';
  currentProfileId: string = '';
  userName: string = '';

  profileName: string = '';
  totalMonthAndLeaveDays: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  totalAbsentDays: any[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  desktopWorkHours: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  totalCheckInHours: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  holidaysList: any[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  constructor(
    private datePipe: DatePipe,
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
  }

  ngOnInit() {
    this.getDaysInYear(new Date().getFullYear());
    this.route.params.subscribe(param => {
      if (param.id) {
        this.currentProfileId = param.id;
      }
    });
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.userName = this.parseService.instance.User.current().get('profile').get('username');

    this.getUserTimeSheetInfo(new Date());
  }

  /* Get desktop logged hours */
  getUserTimeSheetInfo(selectedDate) {
    this.spinner.show();
    var firstDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
    var lastDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
    lastDay = new Date(lastDay.setHours(23, 59, 59, 999));

    let queryInstance = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.currentProfileId != '' ? this.currentProfileId : this.profileId })
    query.greaterThan('createdAt', firstDay);
    query.lessThan('createdAt', lastDay);
    query.include('profileId');
    query.find().then(async result => {
      this.desktopWorkHours = [];
      if (result.length > 0) {
        let i = 0;
        this.profileName = result[0].get('profileId').get('username')
        for (let data of result) {
          i = i + 1;
          let workTime = await this.secondsToHms(data.get('totalAttendance').worktime);
          if (Number(this.datePipe.transform(data.get('createdAt'), 'dd')) != i) {
            let index = Math.abs(Number(this.datePipe.transform(data.get('createdAt'), 'dd')) - this.desktopWorkHours.length);
            for (let i = 0; i < index; i++) { this.desktopWorkHours.push(0) }
            i = Number(this.datePipe.transform(data.get('createdAt'), 'dd'));
            this.desktopWorkHours[i - 1] = workTime;
          }
          else { this.desktopWorkHours.push(workTime); }
        }
        if (this.datePipe.transform(selectedDate, "MMM,y") != this.datePipe.transform(new Date(), "MMM,y")) {
          let reamingHours = Math.abs(this.desktopWorkHours.length - this.month[selectedDate.getMonth()]);
          if (reamingHours != 0) { for (let index = 0; index < reamingHours; index++) { this.desktopWorkHours.push(0); } }
        }
        this.spinner.hide();
      }
      else {
        this.desktopWorkHours = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.totalCheckInHours = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        if (this.datePipe.transform(selectedDate, "MMM d, y") == this.datePipe.transform(new Date(), "MMM d, y")) {
          this.desktopWorkHours.length = selectedDate.getDay();
        }
        else {
          this.totalCheckInHours.length = this.month[Number(selectedDate.getMonth())];
          this.totalCheckInHours.length = this.month[Number(selectedDate.getMonth())];
        }
        this.spinner.hide();
      }
      await this.getCheckInOutInfo(selectedDate);
      await this.generateDynamicColumn(selectedDate, selectedDate.getMonth());
    }).catch(error => {
      this.spinner.hide();
    });
  }

  /* Get Face log check-In hours */
  async getCheckInOutInfo(selectedDate) {
    let month: any = selectedDate.getMonth() + 1;
    if (month < 10) { month = `0${month}` }
    var selectedMonth: any = `${selectedDate.getFullYear()}-${month}`;
    let queryInstance = this.parseService.instance.Object.extend('checkIncheckOutReport');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('month', selectedMonth);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.currentProfileId != '' ? this.currentProfileId : this.profileId });
    query.equalTo('tenantId', this.tenantId);
    query.find().then(async result => {
      if (result.length > 0) {
        this.totalCheckInHours = [];
        var i = 0;
        for (let data of result[0].get('checkInOutDetails')) {
          i = i + 1;
          var outTime = new Date(data.date).getTime();
          var convertIstTimeFormat = new Date(outTime);
          convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
          convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);
          let date = this.datePipe.transform(convertIstTimeFormat, "d");

          if (Number(date) != i) {
            let index = Math.abs(Number(date) - this.totalCheckInHours.length);
            for (let j = 0; j < index; j++) {
              this.totalCheckInHours.push(0);
            }
            i = Number(date);
            this.totalCheckInHours[Number(date) - 1] = Number(data.totalWorkHours.replace(":", "."));
          }
          else if (Number(date) == i) {
            this.totalCheckInHours.push(Number(data.totalWorkHours.replace(":", ".")));
          }
        }
      }
      else {
        this.totalCheckInHours = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.totalCheckInHours.length = this.month[Number(selectedDate.getMonth())];
        this.spinner.hide();
      }
      await this.metricsChart();
    }).catch(error => {
      this.spinner.hide();
    });
  }

  /* Generate dynamic month column */
  async generateDynamicColumn(date, month?: any) {
    this.dynamicDate = [];
    this.totalMonthAndLeaveDays = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (var i = 1; i <= Number(this.month[month]); i++) {
      date.setDate(i);
      date.setMonth(month)
      this.dynamicDate.push(this.datePipe.transform(date, 'EEE, d'));
    }
    /** Calculate Leave days **/
    this.totalMonthAndLeaveDays.length = this.dynamicDate.length;
    let leaveDays = this.dynamicDate.filter(x => x.includes('Sat') || x.includes('Sun'));
    leaveDays = leaveDays.sort((a, b) => { return b - a; });

    for (let data of leaveDays) {
      const [month, day] = data.split(",");
      this.totalMonthAndLeaveDays[day - 1] = Number(8.0);
    }

    await this.calculateAbsentDays();
    await this.getHolyDays(date);
    this.spinner.hide();
  }

  /* Generate absent report based on month */
  async calculateAbsentDays() {
    this.totalAbsentDays = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.totalAbsentDays.length = this.dynamicDate.length;
    if (this.desktopWorkHours.length > 0) {
      let i = 0;
      for (let data of this.desktopWorkHours) {
        i = i + 1;
        if (data > 0) {
          this.totalAbsentDays[i - 1] = 0;
        }
        else if (data == 0) {
          if (this.totalMonthAndLeaveDays[i - 1] != 8) {
            this.totalAbsentDays[i - 1] = Number(8.0);
          }
        }
      }
    }
    this.spinner.hide();
  }

  /* Employee metrics chart */
  async metricsChart() {
    this.chartOptions = {
      chart: {
        type: "column"
      },
      title: {
        text: `Employee work Metrics ( ${this.datePipe.transform(this.selectedDate ? this.selectedDate : new Date(), 'MMM,y')} ) `,
        color: '#2C3460'
      },
      xAxis: {
        categories: this.dynamicDate
      },
      yAxis: {
        title: {
          text: "Work Log",
          color: '#2C3460'
        }
      },
      tooltip: {
        valueSuffix: " "
      },
      series: [{
        name: 'Desktop',
        data: this.desktopWorkHours
      }, {
        name: 'Face log',
        data: this.totalCheckInHours
      },
      {
        name: 'Office Leave',
        data: this.totalMonthAndLeaveDays
      },
      {
        name: 'Leave',
        data: this.totalAbsentDays
      }
      ],
      colors: ['#0C8CE9', '#3EB645E3', '#FFA500', '#FF8181', '#2c3460'],
    };
  }

  /* Employee holiday list */
  async getHolyDays(date) {
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('tenantId', this.tenantId);
    holidayQuery.equalTo('year', date.getFullYear());
    const leaveResults = await holidayQuery.find();
    if (leaveResults.length > 0) {
      this.holidaysList = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.holidaysList = this.dynamicDate.length;
      let data = leaveResults[0].get('holidayDetails');
      data.sort(function (a, b) {
        if (new Date(a.date).getTime() < new Date(b.date).getTime()) { return -1; }
        if (new Date(a.date).getTime() > new Date(b.date).getTime()) { return 1; }
      });
      for (const element of data) {
        if (this.datePipe.transform(element.date, "MMM,y") == this.datePipe.transform(this.selectedDate ? this.selectedDate : new Date(), 'MMM,y')) {
          this.totalAbsentDays[Number((this.datePipe.transform(element.date, "d"))) - 1] = 0;
          this.totalMonthAndLeaveDays[Number((this.datePipe.transform(element.date, "d"))) - 1] = Number(8.0);
        }
      }
    }
  }

  /* Calculate month days */
  getDaysInYear(year) {
    this.month = [];
    for (let month = 0; month < 12; month++) {
      this.month.push(new Date(year, month + 1, 0).getDate());
    }
  }

  backLocation() {
    this.router.navigate(['employees-details']);
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    return Number(hDisplay + '.' + mDisplay);
  }

}
